import { withInstall } from '@antdv/utils';
import pagination from './src/Pagination';

export const Pagination = withInstall(pagination);
export default Pagination;

export * from './src/interface';
export * from './src/props';
